module.exports = __webpack_public_path__ + "static/img/Bachelor_010595.c982b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010595.jpg
// module id = 196
// module chunks = 0